import { isServer } from './platform-utils'

export const decodeFromBase64 = (string: string): string => {
    if (isServer) {
        return Buffer.from(string, 'base64').toString()
    }
    // atob() only handles Latin-1; use TextDecoder to correctly handle UTF-8 (e.g. German umlauts)
    const binaryStr = atob(string)
    const bytes = new Uint8Array(binaryStr.length)
    for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i)
    }
    return new TextDecoder().decode(bytes)
}

export const encodeToBase64 = (string: string): string => {
    if (isServer) {
        return Buffer.from(string).toString('base64')
    }
    // btoa() only handles Latin-1; use TextEncoder to correctly handle UTF-8 (e.g. German umlauts)
    const bytes = new TextEncoder().encode(string)
    let binaryStr = ''
    bytes.forEach(byte => {
        binaryStr += String.fromCharCode(byte)
    })
    return btoa(binaryStr)
}

const BASE_URL = process.env.BASE_URL

const isBase64 = (str: string): boolean => {
    if (!str) {
        return false
    }

    try {
        return encodeToBase64(decodeFromBase64(str)) === str
    } catch {
        return false
    }
}

export const getRelativeURL = (url: string, { encoded = true }: { encoded?: boolean } = {}): string => {
    const base = isServer ? BASE_URL : globalThis.location.origin

    if (!url) {
        const fallback = isServer ? '/' : globalThis.location.pathname + decodeURIComponent(globalThis.location.search)
        return encoded ? encodeToBase64(fallback) : fallback
    }

    try {
        const decoded = isBase64(url) ? decodeFromBase64(url) : url
        const parsed = new URL(decoded, base)
        const relative = parsed.pathname + decodeURIComponent(parsed.search)

        return encoded ? encodeToBase64(relative) : relative
    } catch (error) {
        console.warn('Invalid URL in getRelativeURL:', url, error)
        const fallback = isServer ? '/' : globalThis.location.pathname + decodeURIComponent(globalThis.location.search)
        return encoded ? encodeToBase64(fallback) : fallback
    }
}
